import { computed, makeObservable } from 'mobx'

import { ExtendedColumnConfigProps } from '@new/domains/fastBookingsTapeChart/components/ExtendedColumns/ExtendedColumns.types'
import { arrivalsModeColumns } from '@new/domains/fastBookingsTapeChart/components/ExtendedColumns/ExtendedColumns.utils'
import { fastBookingsTapeChartFiltersStore } from '@new/domains/fastBookingsTapeChart/stores/FastBookingsTapeChartFiltersStore'

export class ArrivalsModeStore {
  constructor() {
    makeObservable(this, {
      isArrivalsModeActive: computed,
      arrivalsModeColumns: computed,
    })
  }

  get isArrivalsModeActive() {
    return fastBookingsTapeChartFiltersStore.arrivalsMode
  }

  get arrivalsModeColumns(): ExtendedColumnConfigProps[] {
    return this.isArrivalsModeActive ? arrivalsModeColumns : []
  }
}

export const arrivalsModeStore = new ArrivalsModeStore()
